var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
import { breakpoints, theme } from '@shapeable/theme';
import { LinearNavigation } from '../elements/linear-navigation';
import { useEntity } from '../hooks/use-entity';
import { GridBackButton } from '../elements/grid-back-button';
import { DottedLine } from '../elements/dotted-line';
var cls = classNames('explorer-navigation');
export var ExplorerNavigationDefaultProps = {
  showIcon: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    width: 100%;\n    flex-direction: row;\n    align-items: center;\n    gap: ", ";\n  "], ["\n    display: flex;\n    width: 100%;\n    flex-direction: row;\n    align-items: center;\n    gap: ", ";\n  "])), theme.UNIT(4))
});
var GridBackButtonStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-shrink: 0;\n  "], ["\n    flex-shrink: 0;\n  "])))
});
var LinearNavigationStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex-grow: 1;\n    flex-basis: 80%;\n    \n    ", " {\n      width: 100%;\n    }\n\n    ", " {\n      padding-left: 0;\n    }\n\n    ", " {\n      padding-right: 0;\n    }\n\n  "], ["\n    flex-grow: 1;\n    flex-basis: 80%;\n    \n    ", " {\n      width: 100%;\n    }\n\n    ", " {\n      padding-left: 0;\n    }\n\n    ", " {\n      padding-right: 0;\n    }\n\n  "])), LinearNavigation.cls.child('select'), LinearNavigation.cls.child('prev-button'), LinearNavigation.cls.child('next-button'))
});
var DividerStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  GridBackButton: styled(GridBackButton).attrs(cls.attr('grid-back-button'))(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), GridBackButtonStyles),
  Divider: styled(DottedLine)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), DividerStyles),
  LinearNavigation: styled(LinearNavigation).attrs(cls.attr('linear-navigation'))(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), LinearNavigationStyles)
};
export var ExplorerNavigation = function (props) {
  var className = props.className,
    icon = props.icon,
    showIcon = props.showIcon;
  var entity = useEntity(props.entity);
  var Icon = !!icon ? icon : GridBackButton;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, showIcon && React.createElement(React.Fragment, null, React.createElement(Icon, null), React.createElement(My.Divider, {
    width: 2,
    gap: 5
  })), React.createElement(My.LinearNavigation, {
    variant: "default",
    value: entity.path
  }));
};
ExplorerNavigation.defaultProps = ExplorerNavigationDefaultProps;
ExplorerNavigation.cls = cls;
// BACK COMPAT
export var EntityGridDetailsNavigation = ExplorerNavigation;
export var EntityGridDetailsNavigationDefaultProps = ExplorerNavigationDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;